import { gql, MutationResult, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { MutationReturnType } from 'basics/types/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const syncCiToVeevaMutationCall = gql`
  mutation syncCiToVeeva($id: String!) {
    syncCiToVeeva(id: $id)
  }
`;

type ResultType = {
  syncCiToVeeva: boolean;
};

type UseSyncCiToVeevaMutation = [
  (id: string) => Promise<MutationReturnType<boolean>>,
  MutationResult<ResultType>,
];

export const useSyncCiToVeevaMutation = (): UseSyncCiToVeevaMutation => {
  const [syncCiToVeeva, state] = useMutation<ResultType>(syncCiToVeevaMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  const executeMutation = useCallback(async (id) => {
    try {
      const { data } = await syncCiToVeeva({
        variables: {
          id,
        },
      });

      return { data: !!data?.syncCiToVeeva, error: null };
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'syncCiToVeeva.ts - useSyncCiToVeevaMutation',
        });

        return { data: null, error: customContext.message as string };
      }

      return { data: null, error: null };
    }
  }, [syncCiToVeeva]);

  return [executeMutation, state];
};
